import { createAction, props } from '@ngrx/store';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IPipeSegment, IPipeSegmentConfig } from '@app/api/interfaces/pipe.interface';
import { IPipesRequestState } from '@app/main/main-screen/store/data/pipes/pipes.state';

export const loadPipes = createAction(
  '[Pipes] Load Pipes',
  props<{ triggerId: string; request: IPipesRequestState }>()
);

export const loadPipesChunk = createAction(
  '[Pipes] Load Pipes Chunk',
  props<{ triggerId: string; segments: IPipeSegment[]; configs?: IPipeSegmentConfig[] }>()
);

export const loadPipesSuccess = createAction(
  '[Pipes] Load Pipes Success',
  props<{ triggerId: string; request: IPipesRequestState }>()
);

export const pipesFailure = createAction(
  '[Pipes] Load Failure',
  props<{ triggerId: string; error: IApiBaseErrorResponse }>()
);

export const loadPipesCancelled = createAction('[Pipes] Load Pipes Cancelled', props<{ triggerId: string }>());
